import React from "react";
import { Routes, Route } from "react-router-dom";

import Landing from "./pages/Landing";
import NotFound from "./pages/NotFound";
import RequireAuth from "./components/RequireAuth";
import PlanRoute from "./components/PlanGate";

import AuthLayout from "./layouts/AuthLayout";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import RegisterCustomer from "./pages/auth/RegisterCustomer";
import ForgotPassword from "./pages/auth/ForgotPassword";

import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ModuleManager from "./pages/admin/ModuleManager";
import Subscription from "./pages/admin/Subscription";
import Addons from "./pages/admin/Addons";
import AdminCart from "./pages/admin/Cart";
import Customers from "./pages/admin/Customers";
import Customer360 from "./pages/admin/Customer360";
import LeadBoard from "./pages/admin/LeadBoard";
import Membership from "./pages/admin/Membership";
import Chat from "./pages/admin/Chat";
import Orders from "./pages/admin/Orders";
import Slips from "./pages/admin/Slips";
import Campaigns from "./pages/admin/Campaigns";
import Calendar from "./pages/admin/Calendar";
import ResourceTimeline from "./pages/admin/ResourceTimeline";
import Appointments from "./pages/admin/Appointments";
import Catalog from "./pages/admin/Catalog";
import Assets from "./pages/admin/Assets";
import Inventory from "./pages/admin/Inventory";
import Pos from "./pages/admin/Pos";
import Billing from "./pages/admin/Billing";
import Payments from "./pages/admin/Payments";
import Installments from "./pages/admin/Installments";
import Commissions from "./pages/admin/Commissions";
import Contracts from "./pages/admin/Contracts";
import FieldService from "./pages/admin/FieldService";
import Organization from "./pages/admin/Organization";
import Branches from "./pages/admin/Branches";
import Staff from "./pages/admin/Staff";
import Roles from "./pages/admin/Roles";
import NotificationSettings from "./pages/admin/NotificationSettings";
import Faqs from "./pages/admin/Faqs";
import ExportData from "./pages/admin/Export";
import Branding from "./pages/admin/Branding";
import TaxInvoices from "./pages/admin/TaxInvoices";
import OnlinePayment from "./pages/admin/OnlinePayment";

import RequireSuperUser from "./components/RequireSuperUser";
import SuperLayout from "./layouts/SuperLayout";
import SuperLogin from "./pages/super/Login";
import SuperOrganizations from "./pages/super/Organizations";
import SuperSales from "./pages/super/Sales";
import SuperRequests from "./pages/super/Requests";
import SuperBoosts from "./pages/super/Boosts";

import PublicLayout from "./layouts/PublicLayout";
import PayPage from "./pages/public/PayPage";

import CustomerLayout from "./layouts/CustomerLayout";
import CustomerDashboard from "./pages/customer/Dashboard";
import CustomerProfile from "./pages/customer/Profile";
import CustomerDocuments from "./pages/customer/Documents";
import CustomerWallet from "./pages/customer/Wallet";
import Store from "./pages/customer/Store";
import ServiceDetail from "./pages/customer/ServiceDetail";
import Booking from "./pages/customer/Booking";
import Bookings from "./pages/customer/Bookings";
import Cart from "./pages/customer/Cart";
import Checkout from "./pages/customer/Checkout";
import CustomerBilling from "./pages/customer/Billing";
import SlipUpload from "./pages/customer/SlipUpload";
import Activity from "./pages/customer/Activity";
import CustomerContracts from "./pages/customer/Contracts";
import CustomerChat from "./pages/customer/Chat";
import Help from "./pages/customer/Help";
import CustomerNotifications from "./pages/customer/Notifications";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Landing />} />

    {/* หน้าสาธารณะ ไม่ต้องล็อกอิน: ลูกค้าเปิดลิงก์ชำระเงินที่ร้านส่งให้ */}
    <Route element={<PublicLayout />}>
      <Route path="/pay/:code" element={<PayPage />} />
    </Route>

    <Route path="/auth" element={<AuthLayout />}>
      <Route path="login" element={<Login />} />
      {/* สมัครฝั่งผู้ดูแล = เปิดร้านใหม่ */}
      <Route path="register" element={<Register />} />
      {/* สมัครฝั่งลูกค้า — ต้องมีรหัสร้านจากลิงก์ของร้าน */}
      <Route path="register/customer" element={<RegisterCustomer />} />
      <Route path="register/customer/:shopCode" element={<RegisterCustomer />} />
      <Route path="forgot" element={<ForgotPassword />} />
    </Route>

    {/* ทีมงานเจ้าของระบบ (super_user ของ PaymentBroker) — ตรวจสิทธิ์กับ Backend ทุกครั้งที่เข้า */}
    <Route path="/su/login" element={<AuthLayout />}>
      <Route index element={<SuperLogin />} />
    </Route>
    <Route
      path="/su"
      element={
        <RequireSuperUser>
          <SuperLayout />
        </RequireSuperUser>
      }
    >
      <Route index element={<SuperOrganizations />} />
      <Route path="sales" element={<SuperSales />} />
      <Route path="requests" element={<SuperRequests />} />
      <Route path="boosts" element={<SuperBoosts />} />
    </Route>

    <Route
      path="/admin"
      element={
        <RequireAuth role="admin">
          <AdminLayout />
        </RequireAuth>
      }
    >
      {/* หน้าแพ็กเกจเข้าได้เสมอ — เป็นทางเดียวที่ร้านยังไม่จ่าย/หมดอายุ จะกลับมาใช้งานได้ */}
      <Route path="subscription" element={<Subscription />} />
      {/* แพ็คเสริม: เติม point / ปั้มไลค์-ฟอลโลว์ ใช้ได้ทันทีไม่ต้องมีแพ็กเกจ (ฟีเจอร์เสริม/โควตาเช็คแพ็กเกจในหน้าเอง) */}
      <Route path="addons" element={<Addons />} />
      {/* ตะกร้า: รวมแพ็กเกจ/ฟีเจอร์เสริม/point จ่าย QR ครั้งเดียว — เข้าได้เสมอเหมือนสองหน้าบน */}
      <Route path="cart" element={<AdminCart />} />

      {/* ที่เหลือต้องมีแพ็กเกจที่ยังไม่หมดอายุ และโมดูลต้องอยู่ในแพ็กเกจนั้น */}
      <Route index element={<PlanRoute><Dashboard /></PlanRoute>} />
      <Route path="modules" element={<PlanRoute><ModuleManager /></PlanRoute>} />
      <Route path="customers" element={<PlanRoute module="crm"><Customers /></PlanRoute>} />
      <Route path="customers/:id" element={<PlanRoute module="crm"><Customer360 /></PlanRoute>} />
      <Route path="leads" element={<PlanRoute module="crm"><LeadBoard /></PlanRoute>} />
      <Route path="membership" element={<PlanRoute module="membership"><Membership /></PlanRoute>} />
      <Route path="chat" element={<PlanRoute module="chat"><Chat /></PlanRoute>} />
      <Route path="orders" element={<PlanRoute module="oms"><Orders /></PlanRoute>} />
      <Route path="slips" element={<PlanRoute module="slip"><Slips /></PlanRoute>} />
      <Route path="campaigns" element={<PlanRoute module="campaign"><Campaigns /></PlanRoute>} />
      <Route path="calendar" element={<PlanRoute module="booking"><Calendar /></PlanRoute>} />
      <Route path="timeline" element={<PlanRoute module="resource"><ResourceTimeline /></PlanRoute>} />
      <Route path="appointments" element={<PlanRoute module="booking"><Appointments /></PlanRoute>} />
      <Route path="catalog" element={<PlanRoute module="catalog"><Catalog /></PlanRoute>} />
      <Route path="assets" element={<PlanRoute module="fleet"><Assets /></PlanRoute>} />
      <Route path="inventory" element={<PlanRoute module="inventory"><Inventory /></PlanRoute>} />
      <Route path="pos" element={<PlanRoute module="pos"><Pos /></PlanRoute>} />
      <Route path="billing" element={<PlanRoute module="billing"><Billing /></PlanRoute>} />
      <Route path="payments" element={<PlanRoute module="billing"><Payments /></PlanRoute>} />
      <Route path="installments" element={<PlanRoute module="installment"><Installments /></PlanRoute>} />
      <Route path="commissions" element={<PlanRoute module="commission"><Commissions /></PlanRoute>} />
      <Route path="contracts" element={<PlanRoute module="contract"><Contracts /></PlanRoute>} />
      <Route path="field-service" element={<PlanRoute module="field_service"><FieldService /></PlanRoute>} />
      <Route path="etax" element={<PlanRoute module="etax"><TaxInvoices /></PlanRoute>} />
      <Route path="online-payment" element={<PlanRoute module="online_payment"><OnlinePayment /></PlanRoute>} />
      <Route path="export" element={<PlanRoute module="data_export"><ExportData /></PlanRoute>} />
      <Route path="branding" element={<PlanRoute module="white_label"><Branding /></PlanRoute>} />
      <Route path="organization" element={<PlanRoute><Organization /></PlanRoute>} />
      <Route path="branches" element={<PlanRoute><Branches /></PlanRoute>} />
      <Route path="staff" element={<PlanRoute><Staff /></PlanRoute>} />
      <Route path="roles" element={<PlanRoute><Roles /></PlanRoute>} />
      <Route path="notifications" element={<PlanRoute><NotificationSettings /></PlanRoute>} />
      <Route path="faqs" element={<PlanRoute><Faqs /></PlanRoute>} />
    </Route>

    <Route
      path="/app"
      element={
        <RequireAuth>
          <CustomerLayout />
        </RequireAuth>
      }
    >
      <Route index element={<CustomerDashboard />} />
      <Route path="profile" element={<CustomerProfile />} />
      <Route path="documents" element={<CustomerDocuments />} />
      <Route path="wallet" element={<CustomerWallet />} />
      <Route path="store" element={<Store />} />
      <Route path="store/:id" element={<ServiceDetail />} />
      <Route path="booking" element={<Booking />} />
      <Route path="bookings" element={<Bookings />} />
      <Route path="cart" element={<Cart />} />
      <Route path="checkout" element={<Checkout />} />
      <Route path="billing" element={<CustomerBilling />} />
      <Route path="slip-upload" element={<SlipUpload />} />
      <Route path="activity" element={<Activity />} />
      <Route path="contracts" element={<CustomerContracts />} />
      <Route path="chat" element={<CustomerChat />} />
      <Route path="help" element={<Help />} />
      <Route path="notifications" element={<CustomerNotifications />} />
    </Route>

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
